import { ReactComponent as UsersSidebarSvg } from "../../assets/images/svgs/usersSidebar.svg";

const UsersSidebarIcon = ({ className = "", ...props }) => {
  return (
    <UsersSidebarSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default UsersSidebarIcon;
